import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import instagram from "../../assets/instagram.svg";
import linkedIn from "../../assets/linkedin.svg";
import regLogo from "../../assets/regulate-logo.svg";
import rightArrow from "../../assets/right-arrow.svg";
import twitter from "../../assets/twitter.svg";
import linkedinHover from "../../assets/linkedinHover.svg";
import twitterHover from "../../assets/twitterHover.svg";
import instagramHover from "../../assets/instagramHover.svg";

import "./style.css";

const Footer = () => {
  const date = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const toastRef = useRef(null);
  const [toastMsg, setToastMsg] = useState("");
  const [toastType, setToastType] = useState("success");
  const [socialMediaHover, setSocialMediaHover] = useState(null)

  const socailMedia = [
    {
      id: 1,
      icon: linkedIn,
      hoverIcon: linkedinHover,
      link: "https://www.linkedin.com/company/regulatecpg"
    },
    {
      id: 2,
      icon: instagram,
      hoverIcon: instagramHover,
      link: "https://www.instagram.com/regulatecpg/"
    },
    {
      id: 3,
      icon: twitter,
      hoverIcon: twitterHover,
      link: "https://x.com/Regulate_CPG"
    },
  ]

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const showToast = () => {
    const toastEl = toastRef.current;
    if (toastEl) {
      const toast = new window.bootstrap.Toast(toastEl);
      toast.show();
    }
  };

  const handleEmail = () => {
    const trimmedEmail = email.trim();

    if (!isValidEmail(trimmedEmail)) {
      setToastMsg("Please enter a valid email address.");
      setToastType("danger");
      setTimeout(showToast, 0);
      return;
    }

    setToastMsg("Thank you for subscribing!");
    setToastType("success");

    setTimeout(showToast, 0);
    setEmail("");
  };

  return (
    <div className="d-flex justify-content-center align-items-center  w-100">
      <div className="footer-container section-container ">
        <div className="d-flex justify-content-center align-items-start action-container">
          <div className="logo-container d-flex flex-column">
            <Link to="/" className="footer-action-text">
              <img src={regLogo} alt="" className="reg-logo" />
            </Link>
            <span className="help-text" style={{ paddingTop: "1.25rem" }}>
              Regulate helps CPG brands launch products to retailshelves faster
              and safer with the power of AI and NLP.
            </span>
          </div>
          <div className="nav-container">
            <div className="resources-container">
              <div className="sub-title">Resources</div>
              <Link to="/faqs" className="footer-action-text">
                FAQ
              </Link>
              <Link to="/media?tab=Videos" className="footer-action-text">
                Video Tutorials
              </Link>
              <div >
                <Link to="/media" className="footer-action-text">
                  See All Resources
                </Link>
                <span style={{ marginLeft: "0.425rem" }} className="footer-action-text">
                  &gt;
                </span>
              </div>
            </div>
            <div className="get-in-touch">
              <div className="sub-title">Get In Touch</div>
              <Link to="/contact" className="footer-action-text">
                Contact Us
              </Link>
              <div className="footer-action-text d-flex flex-column">
                <a href="mailto: hello@regulatecpg.com"> hello@regulatecpg.com</a>
                <span>510-671-8300</span>
              </div>
              <div className="address">
                1028 SE Water Ave. <div></div> Portland, OR 97214
              </div>

              <div className="social-media-container">
                {
                  socailMedia?.map((item) => {
                    return (
                      <Link to={item?.link} className="social-media" target="_blank"
                        onMouseEnter={() => setSocialMediaHover(item?.id)}
                        onMouseLeave={() => setSocialMediaHover(null)}
                        style={socialMediaHover == item?.id ? {
                          padding: "0"
                        } : {}}
                      >
                        {
                          socialMediaHover === item?.id ? <img src={item?.hoverIcon} alt="" style={{ width: "2rem", height: "2rem" }} /> : <img src={item?.icon} alt="" style={{ width: "1rem", height: "1rem" }} />
                        }
                      </Link>
                    )
                  })
                }
              </div>
            </div>
            <div className="newsletter-container">
              <div className="sub-title">Subscribe to Newsletter</div>
              <span className="info-text">
                Join 4,000+ CPG innovators. Monthly roundup of the best
                compliance tips and trend signals, straight to your inbox.
              </span>
              <div className="input-container">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="info-text"
                  value={email}
                  style={{ height: "2.5rem", border: "none", width: "100%" }}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleEmail();
                    }
                  }}
                />
                <div className="send-email" onClick={handleEmail}>
                  <img src={rightArrow} alt="" style={{ height: "1rem" }} />

                  {/* <div className="btn-icon-container">
                    {" "}
                    <img
                      src={rightArrow}
                      alt="Arrow"
                      className="icon-default"
                    />
                    <img src={rightArrow} alt="Arrow" className="icon-hover" />
                  </div> */}
                </div>
              </div>
            </div>{" "}
          </div>
        </div>
        <div className="copyright-container d-flex justify-content-between flex-wrap gap-3">
          <div>Copyright © {date} D&H Technology. All Rights Reserved.</div>
          <div className="d-flex gap-3 flex-wrap">
            <a
              href="https://app.regulatecpg.com/terms-and-conditions"
              target="_blank"
              rel="noreferrer"
            >
              Terms & Conditions
            </a>
            <a
              href="https://app.regulatecpg.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
        <div
          className="toast-container position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: 9999 }}
        >
          <div
            className={`toast align-items-center text-bg-${toastType} border-0`}
            ref={toastRef}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-bs-delay="3000"
            data-bs-autohide="true"
          >
            <div className="d-flex">
              <div className="toast-body">{toastMsg}</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                data-bs-dismiss="toast"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default Footer;
